import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

type PropsType = {
  onSortUp: () => void
  onSortDown: () => void
  disabled?: boolean
}

const TableSortActions = ({ onSortUp, onSortDown, disabled = false }: PropsType) => {
  return (
    <div className="flex flex-row items-center justify-center">
      <Button
        variant="ghost"
        size="sm"
        onClick={e => {
          e.stopPropagation()
          onSortUp()
        }}
        disabled={disabled}>
        <ArrowUpIcon size="12" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={e => {
          e.stopPropagation()
          onSortDown()
        }}
        disabled={disabled}>
        <ArrowDownIcon size="12" />
      </Button>
    </div>
  )
}

export default TableSortActions
